exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-grid-icon-column[data-v-2f69df90] {\n  display: none;\n}\n", ""]);

// exports
